import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
	state: {
		activeChannels: [],
	},
	actions,
	getters,
	mutations,
};
